function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.74,18.87c-5.95,0-9.2,1.25-13.32,5.15C5,28.25,2.47,33.33,2.91,40.15A159.35,159.35,0,0,0,5.26,59.43c.47,2.58,1.54,6.34,0,9.13a11.77,11.77,0,0,0,.58,12.11c2.28,3.45,5.09,7,8.69,7.31,2.76.26,4-1.29,5-5.45,1.06-4.78.59-7.94-.57-10.24-1.56-3.07-4.12-5.25-6.35-11.42C11,56.5,9.82,46.67,10.26,38.13c.35-6.53,1.74-8.23,5.39-10.72C19.49,24.81,26,26.14,26,26.14l4.7-5.75S28.3,18.88,22.74,18.87ZM10.88,71.65c1.23-.25,2.72,1.09,3.33,3s.09,3.67-1.15,3.92-2.72-1.09-3.32-3S9.64,71.91,10.88,71.65Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "72.58 44.21 28.28 44.21 21.89 40.72 21.89 45.84 12.93 40.72 12.93 54.68 21.89 49.88 21.89 54.68 28.28 51.19 72.58 51.19 72.58 44.21"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.89,59.12H25.8c.06.54.11,1.12.17,1.61.8,6.65,4.07,14.7,4.92,22.75C31.83,92.25,32,99.31,32,99.31h6.91s-.13-16.08-3.06-25.66A95.66,95.66,0,0,1,32.89,59.12Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M70.81,18.23C53.62,16.41,42.33,16.56,35.15,20,29.76,22.61,25.3,29.86,25,36c0,.27,0,.6,0,.88h7.33c.46-3.11,1.47-6.12,4-8.06,4.52-3.46,11.33-4.12,16.1-3.86,8.6.48,22.76,1.38,29.93,1.87s14.76.92,14.76.92V20S84,19.62,70.81,18.23Z"
});

var SvgHnIconsInseminationBlue = function SvgHnIconsInseminationBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHnIconsInseminationBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HN_icons_Insemination-Blue.6f172e9f.svg";
export { ForwardRef as ReactComponent };